(() => {
	function init() {
		$('#js-service-slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			appendDots: '#js-service-pagination',
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				}
			]
		});

		$('#js-projects-slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true,
			appendDots: '#js-projects-pagination',
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				}
			]
		});

		$('#js-testimonials-slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: '#js-testimonials-prev',
			nextArrow: '#js-testimonials-next',
			dots: false,
			mobileFirst: true,
			cssEase: 'cubic-bezier(.92,.25,.12,1)',
			speed: 500
		});
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		if ($BODY.hasClass('index-page')) init();
	});
})();
